import { Injectable} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import {CoreService} from "./core.service";

@Injectable({
  providedIn: 'root'
})
export class MainLayoutService {
  private _isAppStoreBannerVisible$ = new BehaviorSubject<boolean>(false);

  get isAppStoreBannerVisible$(): Observable<boolean> {
    return this._isAppStoreBannerVisible$.asObservable();
  }

  constructor(
    private titleService: Title,
    private coreService: CoreService
  ) { }

  showAppStoreBanner(): void {
    setTimeout(() => {
      this._isAppStoreBannerVisible$.next(true);
    });
  }

  hideAppStoreBanner(): void {
    setTimeout(() => {
      this._isAppStoreBannerVisible$.next(false);
    });
  }

  /**
   Provide the desired page title fragment. The page title will be formatted as

   <fragment> | <brand name>

   The brand will be formatted based on what's already been loaded in the theme.
   */
  setPageTitle(titleFragment?: string): void {
    // by default, title is brand name
    let title: string = this.coreService.brandNameSubject.value;

    // if a title fragment is provided, format accordingly
    if (titleFragment) {
      title = `${titleFragment} | ${this.coreService.brandNameSubject.value}`;
    }

    // TODO - Refactor for multi product
    // this.titleService.setTitle(title);
  }
}
